import { getLink } from '../../../utils/utils';

import author from './author';

const content = {
  esp: (
    `
    <div class="poem">

      <p class="poem-block mb-3">
        Ho, Eŭropo!<br/>
        En XV jc vi bruligis viajn sorĉistinojn en la fajroj surplace. Mezepoko…
      </p>

      <p class="poem-block mb-3">
        En XX jc vi bruligis viajn civitanojn de ajna sekso kaj aĝo en la fornegoj. Progreso!
      </p>

      <p class="poem-block mb-3">
        En XXI jc vi bruligas pneŭojn en la fajroj surplace. Degenero.
      </p>

      <p class="poem-block mb-3">
        Ho ve, Eŭropo, Eŭropo!<br/>
        Kien vi ruliĝas tiel senbride, kiel brulantaj pneŭoj? Kio atendas vin fine de deklivo?
      </p>

      <p class="poem-block mb-3">
        Neniu respondas.
      </p>
    </div>
    `
  )
}

const itemName = {
  esp: 'Kanto de neEŭropa homo de XXI jc'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp:{
    itemName: itemName.esp,
    itemContent: content.esp,
    itemAuthor: author.esp
  }
}

export default item;